interface MapProps {
    location: string;
    className?: string;
}

const Map: React.FC<MapProps> = ({ location, className }) => {
    const mapUrl = `https://maps.google.com/maps?q=${encodeURIComponent(location)}&output=embed`;

    return (
        <iframe
            src={mapUrl}
            className={className}
            loading="lazy"
        />
    );
};

export default Map;


